import { render, staticRenderFns } from "./BatchAction.vue?vue&type=template&id=caefe3b4&"
import script from "./BatchAction.vue?vue&type=script&lang=ts&"
export * from "./BatchAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports